import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { Task } from "./useTaskCreateMutation";

type wbsImportResponse = ResponseType<Task[]>;

function useWbsImportMutation(projectId?: string) {
  const mutation = useMutation<
    AxiosResponseAndError<wbsImportResponse>["response"],
    AxiosResponseAndError<wbsImportResponse>["error"],
    FormData
  >({
    mutationFn: (data) =>
      ApiRequest.post<wbsImportResponse>(
        `${requestURLs.wbsTask}${projectId}`,
        data
      ),
  });

  return mutation;
}

export default useWbsImportMutation;
